<template>
  <div class="event-form">
    <h2 class="title">{{ title }}</h2>
    <p
      v-if="subtitle"
      class="subtitle"
    >
      {{ subtitle }}
    </p>
    <form
      v-if="!noInputs"
      @submit.prevent="authorizeEmail()"
    >
      <div class="input-wrapper">
        <label :for="nameId">Full name</label>
        <input
          :id="nameId"
          v-model="name"
          type="text"
          class="input"
        />
      </div>
      <div class="input-wrapper">
        <label :for="emailId">Email</label>
        <input
          :id="emailId"
          v-model="email"
          type="email"
          required
          class="input email-input"
          :class="{
            'input-error': !isValidEmail || alreadyJoinedError,
          }"
        />
        <span
          v-if="alreadyJoinedError"
          class="error error-400"
        >
          You’ve already confirmed attendance to this event
        </span>
      </div>
      <button
        type="submit"
        class="btn submit-btn"
      >
        {{ submitText }}
      </button>
    </form>
    <div
      v-if="!noInputs"
      class="action"
    >
      <span>Not a member yet?</span>
      <ApplyButton
        class="apply-btn"
        cta-section="register-form"
        page-name="events-detail"
      />
    </div>
    <button
      v-else
      type="submit"
      class="btn submit-btn second-submit-btn"
      @click="authorizeEmail()"
    >
      {{ submitText }}
    </button>
  </div>
</template>

<script>
import ApplyButton from '~/components/Common/ApplyButton/ApplyButton.vue';
import { validateEmail } from '~/utils/helpers/validators';

export default {
  components: { ApplyButton },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    submitText: {
      type: String,
      default: '',
    },
    alreadyJoinedError: {
      type: Boolean,
      default: false,
    },
    noInputs: {
      type: Boolean,
      default: true,
    },
    onApplyNow: {
      type: Function,
      default: () => {},
    },
    onSubmit: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isValidEmail: true,
      name: '',
      email: '',
      nameId: `name-${Math.random().toString(36).slice(2)}`,
      emailId: `email-${Math.random().toString(36).slice(2)}`,
    };
  },
  methods: {
    authorizeEmail() {
      if (this.$localStorage.getItem('events_email') !== null) {
        this.email = this.$localStorage.getItem('events_email');
      }

      this.isValidEmail = validateEmail(this.email);

      if (this.isValidEmail) {
        this.onSubmit(this.email);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './EventForm.scss';
</style>
